import { render, staticRenderFns } from "./EmulatorInitialization.vue?vue&type=template&id=2572857f&scoped=true"
import script from "./EmulatorInitialization.vue?vue&type=script&lang=js"
export * from "./EmulatorInitialization.vue?vue&type=script&lang=js"
import style0 from "./EmulatorInitialization.vue?vue&type=style&index=0&id=2572857f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2572857f",
  null
  
)

export default component.exports